<template>
    <div class="flex items-center">
        <div class="flex w-full bg-white">
            <div class="relative text-gray-600 focus-within:text-gray-400 w-full">
                <div class="absolute inset-y-0 left-0 flex items-center pl-2">
                    <button type="button" class="p-1 focus:outline-none focus:shadow-outline">
                        <i class="fas text-gray-900 fa-search text-sm" />
                    </button>
                </div>
                <input
                    type="text"
                    name="q"
                    class="
                        w-full pl-8 flex border border-solid border-black
                        rounded-md focus:outline-none focus:bg-white focus:text-gray-900
                        text-sm
                    "
                    :class="[`h-${height}`]"
                    :value="value"
                    @input="$emit('input', $event.target.value)"
                    :placeholder="placeholder"
                    autocomplete="off"
                >
            </div>
        </div>
    </div>
</template>

<script>
import eventBus from "/resources/js/Layouts/eventBus.vue";

export default {
    props: {
        value: String,
        maxWidth: {
            type: Number,
            default: 300
        },
        height: {
            type: String,
            default: '10'
        },
        placeholder: {
            type: String,
            default: 'Buscar'
        },
    },
    created() {
        eventBus.$on("clearFilter", () => {
            this.$emit('input', null);
        });
    }
}
</script>
